<div class="home-page-banner-wrapper" *ngIf="!isMobile" [ngClass]="{'non-logged-in-type': type === 'non_logged_in'}">
  <div class="cloud-wraps">
    <div class="top-cloud-wrapper">
      <img data-src="/assets/images/home-v2/top-cloud.png" class="top-cloud" alt="cloud top" />
    </div>
    <div class="left-cloud-wrapper">
      <img data-src="/assets/images/home-v2/left-cloud.png" class="left-cloud" alt="cloud left" />
    </div>
    <div class="bottom-cloud-wrapper">
      <img data-src="/assets/images/home-v2/bottom-cloud.png" class="bottom-cloud" alt="cloud bottom" />
    </div>
  </div>
  <div class="banner-body">
    <div class="content-section">
      <div class="main-title">
        {{info?.title}}
      </div>
      <div class="birds-img-wrapper">
        <img src="/assets/images/home-v2/birds-desktop.png" alt="bird desktop">
      </div>
      <div class="short-desc">
        {{info?.shortdesc}}
      </div>
      <div class="hr"></div>
      <div class="counts-wrapper" *ngIf="!isCountsLoading">
        <!-- based on condition this section changes only two variant -->
        <div class="count-column" *ngFor="let item of info?.countData; index as i">
          <div class="content-data">
            <div class="numeric-data">
              <em *ngIf="item.isHeart" class="material-icons">favorite</em>
              {{item.count}}</div>
            <div class="desc">{{item.desc}}</div>
          </div>
          <div class="vr" *ngIf="i < info?.countData.length - 1"></div>
        </div>
      </div>
      <div class="counts-wrapper is-loading" *ngIf="isCountsLoading">
        <div class="loading-section"></div>
      </div>
      <div class="hr"></div>
      <div class="non-loggedin-wrapper" *ngIf="type==='non_logged_in'">
        <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
      </div>
    </div>
    <div class="slider-section" *ngIf="!isLoading">
      <!-- based on condition this section varies total 4 variant-->
      <!-- make a change -->
      <ng-container *ngIf="type==='default'">
        <ng-container *ngTemplateOutlet="makeAChangeRef"></ng-container>
      </ng-container>
      <!--  make a difference -->
      <ng-container *ngIf="type==='donate_again'">
        <ng-container *ngTemplateOutlet="makeADiffRef"></ng-container>
      </ng-container>

      <!--  View my impact-->
      <ng-container *ngIf="type==='update'">
        <ng-container *ngTemplateOutlet="viewMyImpactRef"></ng-container>
      </ng-container>

      <ng-container *ngIf="type==='non_logged_in'">
        <ng-container *ngTemplateOutlet="nonLoggedInRef"></ng-container>
      </ng-container>
      <!-- download the app -->

      <ng-container *ngIf="type==='download_app'">
        <ng-container *ngTemplateOutlet="downloadAppRef"></ng-container>
      </ng-container>
    </div>
    <div class="slider-section is-loading" *ngIf="isLoading">
      <div class="loading-section"></div>
    </div>
  </div>
</div>

<div class="home-page-banner-wrapper" [ngClass]="{'non-logged-in-type': type === 'non_logged_in'}" *ngIf="isMobile">
  <div class="cloud-wraps" *ngIf="type === 'non_logged_in'">
    <div class="top-cloud-wrapper">
      <img data-src="/assets/images/home-v2/top-cloud-mweb.png" class="top-cloud" alt="cloud top" />
    </div>
    <div class="left-cloud-wrapper">
      <img data-src="/assets/images/home-v2/left-cloud.png" class="left-cloud" alt="cloud left" />
    </div>
  </div>
  <div class="top-section">
    <div class="main-title">
      {{info.title}}
    </div>
    <div class="birds-img-wrapper" *ngIf="type === 'non_logged_in'">
      <img src="/assets/images/home-v2/birds-desktop.png" alt="bird desktop">
    </div>
    <div class="sub-title">
      <div class="line" *ngIf="type !== 'non_logged_in'"></div>
      {{info.shortdesc}}
      <div class="line" *ngIf="type !== 'non_logged_in'"></div>
    </div>
  </div>
  <div class="slider-section" *ngIf="!isLoading">
    <ng-container *ngIf="type === 'default'">
      <ng-container *ngTemplateOutlet="makeAChangeRef"></ng-container>
    </ng-container>
    <ng-container *ngIf="type === 'donate_again'">
      <ng-container *ngTemplateOutlet="makeADiffRef"></ng-container>
    </ng-container>
    <ng-container *ngIf="type === 'update'">
      <ng-container *ngTemplateOutlet="viewMyImpactRef"></ng-container>
    </ng-container>
    <ng-container *ngIf="type==='non_logged_in'">
      <ng-container *ngTemplateOutlet="nonLoggedInRef"></ng-container>
    </ng-container>
    <ng-container *ngIf="type === 'download_app'">
      <ng-container *ngTemplateOutlet="downloadAppRef"></ng-container>
    </ng-container>
  </div>
  <div class="loading is-loading" *ngIf="isLoading">
    <div class="loading-section"></div>
  </div>
  <div class="counts-wrapper">
    <!-- based on condition this section changes only two variant -->
    <div class="count-column" *ngFor="let item of info?.countData; index as i">
      <div class="content-data">
        <div class="numeric-data">
          <em *ngIf="item.isHeart" class="material-icons">favorite</em>
          {{item.count}}</div>
        <div class="desc">{{item.desc}}</div>
      </div>
      <div class="vr" *ngIf="i < info?.countData.length - 1"></div>
    </div>
  </div>
  <div class="non-loggedin-wrapper" *ngIf="type==='non_logged_in'">
    <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
  </div>
</div>

<ng-template #makeAChangeRef>
  <div class="make-a-change-wrapper">
    <div class="top-slider-wrapper">
      <ngx-glide [showArrows]="false" [showBullets]="true" [perView]="1" [bound]="true" [gap]="20">
        <div class="slide" *ngFor="let item of info.topSliderContent">
          <div class="content-wrapper">
            <video class="video" width="100%" height="100%" #videoPlayer preload controlsList="nodownload" playsinline>
              <source [src]="item.url+'#t=0.001'" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div class="play-btn-wrapper" *ngIf="item.pause" (click)="openDialog(item)">
            <img src="/assets/images/home-v2/play-icon.png" alt="play icon">
          </div>
        </div>
      </ngx-glide>
    </div>
   <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
  </div>
</ng-template>

<ng-template #mysipDonateMoreBtnRef> 
  <div class="bottom-btn-wrapper multi-sip">
    <button mat-button class="btn white" (click)="onViewAllSip()">
      <div class="text">
         View All My SIP
      </div>
    </button>
    <button mat-button class="btn" (click)="onBottmBtnClicked()">
      <div class="text">
        Contribute More
      </div>
    </button>
  </div>
</ng-template>

<ng-template #bottomBtnRef>
  <div class="bottom-btn-wrapper">
    <button mat-button class="btn" (click)="onBottmBtnClicked()">
      <div class="text">
        {{info.btnTitle}}
      </div>
      <div class="icon-wrap">
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </button>
  </div>
</ng-template>

<ng-template #makeADiffRef>
  <div class="make-a-diff-wrapper" *ngIf="sipSubsCount === 0 || configSipPosition ==='showDefault'">
    <div class="donation-wrapper">
      <div class="top-section">
        <div class="main-img-wrapper">
          <img [attr.data-src]="campaign?.theater?.cdn_path || campaign?.widget?.cdn_path || util.defaultImg" alt="campaign image">
        </div>
        <div class="content">
          <div class="title">
            {{campaign.title}}
          </div>
          <div class="desc">
            Help him with life changing funds!
          </div>
        </div>
      </div>
      <div class="hr"></div>
      <div class="campaign-details-wrapper">
        <div class="funds-wrap">
          <div class="title">
            Funds raised
          </div>
          <div class="data">
            {{campaign.raised.raised | inrFormat:util.currency.getValue()}}
          </div>
        </div>
        <div class="campaign-ends-wrap">
          <div class="title">
            Campaign end in
          </div>
          <div class="data red">
            <span *ngIf="(campaign?.end_date | dayjs:'diffInDays') >= 0" class="days">{{(campaign?.end_date | dayjs:'diffInDays':1) | inrFormat:'INR'}} {{(campaign?.end_date | dayjs:'diffInDays':1) > 1 ? 'Days' : 'Day'}}</span>
            <span *ngIf="(campaign?.end_date | dayjs:'diffInDays') < 0" class="days">Fundraiser Ended</span>
          </div>
        </div>
      </div>
      <div class="progress-bar-wrapper">
        <!-- amount => campaign raised raised and goal => campaign amount requested -->
        <app-progress-bar [amount]="campaign?.raised?.raised" [goal]="campaign?.amount_requested"></app-progress-bar>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
  </div>
  <div class="make-a-diff-wrapper" *ngIf="sipSubsCount === 1 && configSipPosition !== 'showDefault'">
    <app-banner-sip-detail-card (emitOnResumeSip)="onSipResumeEmit.emit($event)" [activeSipSubscribed]="activeSipSubscribed[0]" />
    <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
  </div>
  <div class="make-a-diff-wrapper" *ngIf="sipSubsCount > 1 && configSipPosition !== 'showDefault'">
    <app-banner-multisip-detail-card [activeSipSubscribed]="activeSipSubscribed" (emitOnResumeSip)="onSipResumeEmit.emit($event)" />
    <ng-container *ngTemplateOutlet="mysipDonateMoreBtnRef"></ng-container>
  </div>
</ng-template>

<ng-template #viewMyImpactRef>
  <div class="view-my-impact-wrapper">
    <div class="slider-container" (click)="onViewMyImpactClicked()">
      <img src="/assets/images/home-v2/viewmyimpact.png" alt="view my impact" />
    </div>
    <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
  </div>
</ng-template>

<ng-template #nonLoggedInRef>
  <div class="non-logged-in-v2-wrapper">
    <div class="slider-container">
      <img src="/assets/images/home-v2/banner-non-loggedin.png" alt="banner image" />
    </div>
  </div>
</ng-template>

<ng-template #downloadAppRef>
  <div class="download-app-wrapper">
    <div class="main-border">
      <div class="blank">
        <div class="content" (click)="onBottmBtnClicked()">
          <div class="logo"><img loading="lazy" [attr.data-src]="'/assets/images/download_app.png'" alt=""></div>
          <div class="text">
            <div class="title">Download the Ketto app!</div>
            <div class="sub-title">Make good things happen & get rewarded</div>
          </div>
          <div class="icon-wrap">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="act-btn">

    </div>
    <ng-container *ngTemplateOutlet="bottomBtnRef"></ng-container>
  </div>
</ng-template>

<ng-template #dialogVideoRef>
  <div class="video-dialog-wrapper">
    <app-close-btn top="-12px" right="-10px"></app-close-btn>
    <video *ngIf="!isMobile" controls width="550px" autoplay height="310px" controlsList="nodownload">
      <source [src]="dialogDataUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <video *ngIf="isMobile && selectedVideo?.id !== 1" controls width="320px" autoplay height="340px" controlsList="nodownload" plays-inline>
      <source [src]="dialogDataUrl+'#t=0.001'" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <video *ngIf="isMobile && selectedVideo?.id === 1" controls autoplay height="220px" width="320px" controlsList="nodownload" plays-inline>
      <source [src]="dialogDataUrl+'#t=0.001'" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</ng-template>